Vendd.Scripts.load(function () {
    var $form = $('.x-callmeback-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        firstName: $("input[name='firstName']", $form).val() ? $("input[name='firstName']", $form).val() : "",
        lastName: $("input[name='lastName']", $form).val() ? $("input[name='lastName']", $form).val() : "",
        email: $("input[name='email']", $form).val() ? $("input[name='email']", $form).val() : "",
        phone: $("input[name='phone']", $form).val() ? $("input[name='phone']", $form).val() : "",
        message: $("input[name='message']", $form).val() ? $("input[name='message']", $form).val() : "",
        reCaptchaCode: ""
    };

    var captchaId = "callMeBackCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data.success && data.code === "CallMeBack_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();

            $('.js-success', $form).show();
            form.removeRecaptcha();

        } else {
            $('.js-error', $form).show();
            form.resetRecaptcha();
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
        form.resetRecaptcha();
    };

    form.submit = function () {
        form.loading(true);

        $('input:not([type="checkbox"]), textarea:not([name="g-recaptcha-response"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.CallMeBack.Messages.Submit(
            formData.email,
            formData.firstName,
            formData.lastName,
            formData.phone,
            formData.message,
            formData.reCaptchaCode
        ));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="phone"]', $form).val("");
        $('input[name="message"]', $form).val("");

        cmbf.reset();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cmbf.validate();
        var val2 = form.validateRecaptcha();

        if (val1 && val2) form.submit();

        initialValidation = true;
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        if (e.keyCode === 13) {

            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        }

        form.setField($(this));
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "email") {
                cmbf.validateField("email");
            }

            if ($(this).attr('name') === "phone") {
                cmbf.validateField("phone");
            }
        }

        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        cmbf.validate(fieldName);
    };

    //init validation options
    var validationOptions = {}, initialValidation = false;

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        validationOptions[inputName] = { required: inputName + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        validationOptions.email = validationOptions.email || {};
        validationOptions.email = { ...validationOptions.email, ...{ isEmail: 'email-invalid' } };
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        validationOptions.phone = validationOptions.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            validationOptions.phone = { ...validationOptions.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'both' } } } };
        } else {
            validationOptions.phone = { ...validationOptions.phone, ...{ isPhoneNumber: 'phone-invalid' } };
        }
    }

    $form.validationEngine(validationOptions);
    var cmbf = $form.data('validationEngine');

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                cmbf = $form.data('validationEngine');
                cmbf.validate('phone');
            });
        }
    }

    Vendd.MessageBus.subscribe(Vendd.CallMeBack.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.CallMeBack.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

});
